import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'


interface GuidedAssessmentComponentProps {
    levels: number[]
    canEditGuided: boolean
    handleScoreChange: (field: keyof GuidedAssessmentScoreState, value: number | string) => void
    currentScore: GuidedAssessmentScoreState
    levelDescriptions: Record<number, string>
    selfAssessmentPending?: boolean
}

interface GuidedAssessmentScoreState {
    leaderLevel: number | null
    guidedNotes: string
}

const GuidedAssessmentComponent = ({ levels, canEditGuided, handleScoreChange, currentScore, levelDescriptions, selfAssessmentPending }: GuidedAssessmentComponentProps) => {
    return (
        <div className="card-body">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h2 className="h6 fw-semibold mb-0">Guided Assessment</h2>
                {(!canEditGuided || selfAssessmentPending) && (
                    <span className="badge bg-light text-muted border">Read-only</span>
                )}
            </div>

            <div className="mb-4">
                <label className="form-label fw-semibold text-muted small mb-2">
                    Guided Score (1-5)
                </label>
                <div className="d-flex gap-2">
                    {levels.map((level) => (
                        <button
                            key={level}
                            type="button"
                            disabled={!canEditGuided}
                            onClick={() => handleScoreChange('leaderLevel', level)}
                            className={`gw-score-button gw-score-button--guided ${currentScore.leaderLevel === level ? 'is-active' : ''
                                }`}
                        >
                            <span className="h5 mb-0">{level}</span>
                        </button>
                    ))}
                </div>
            </div>

            {currentScore.leaderLevel && (
                <div className="mb-4 gw-assessment-level-card gw-assessment-level-card--guided">
                    <div className="d-flex gap-2">
                        <FontAwesomeIcon
                            icon={faCircleInfo}
                            className="gw-assessment-level-icon"
                        />
                        <div>
                            <div className="fw-semibold small mb-1">
                                Level {currentScore.leaderLevel} definition
                            </div>
                            <p className="small mb-0">
                                {levelDescriptions[currentScore.leaderLevel]}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div>
                <label className="form-label fw-semibold text-muted small mb-2">
                    Admin Notes
                </label>
                <textarea
                    disabled={!canEditGuided}
                    value={currentScore.guidedNotes}
                    onChange={(event) => handleScoreChange('guidedNotes', event.target.value)}
                    placeholder="Add feedback, observations, or development suggestions..."
                    rows={6}
                    className={`form-control gw-assessment-textarea gw-assessment-textarea--guided ${!canEditGuided ? 'bg-light' : ''
                        }`}
                />
            </div>
        </div>
    )
}

export default GuidedAssessmentComponent